module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Distributed by Radius Book Group"), _c('br'), _vm._v("\n  A Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n  443 Park Avenue South, Suite 1008"), _c('br'), _vm._v("\n  New York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.radiusbookgroup.com",
      "target": "_blank"
    }
  }, [_vm._v("www.RadiusBookGroup.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Copyright © 2016 by Tim Ryan"), _c('br'), _vm._v("\n  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("First edition: September 2016"), _c('br'), _vm._v("\n  eBook ISBN: 978-1-68230-675-8"), _c('br'), _vm._v("\n  Hardcover ISBN: 978-1-68230-674-1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f17752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 63
// module chunks = 0